/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_YearInputs */

const en_shared_year = /** @type {(inputs: Shared_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`year`)
};

const de_shared_year = /** @type {(inputs: Shared_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahr`)
};

const es_shared_year = /** @type {(inputs: Shared_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`año`)
};

const fr_shared_year = /** @type {(inputs: Shared_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`année`)
};

const nl_shared_year = /** @type {(inputs: Shared_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jaar`)
};

/** @type {(inputs: Shared_YearInputs) => LocalizedString} */
const it_shared_year = en_shared_year;

/** @type {(inputs: Shared_YearInputs) => LocalizedString} */
const pt_br2_shared_year = en_shared_year;

/** @type {(inputs: Shared_YearInputs) => LocalizedString} */
const pl_shared_year = en_shared_year;

/** @type {(inputs: Shared_YearInputs) => LocalizedString} */
const hu_shared_year = en_shared_year;

/** @type {(inputs: Shared_YearInputs) => LocalizedString} */
const ro_shared_year = en_shared_year;

/**
* | output |
* | --- |
* | "year" |
*
* @param {Shared_YearInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_year = /** @type {((inputs?: Shared_YearInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_YearInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_year(inputs)
	if (locale === "de") return de_shared_year(inputs)
	if (locale === "es") return es_shared_year(inputs)
	if (locale === "fr") return fr_shared_year(inputs)
	if (locale === "nl") return nl_shared_year(inputs)
	if (locale === "it") return it_shared_year(inputs)
	if (locale === "pt-BR") return pt_br2_shared_year(inputs)
	if (locale === "pl") return pl_shared_year(inputs)
	if (locale === "hu") return hu_shared_year(inputs)
	return ro_shared_year(inputs)
});
export { shared_year as "shared.year" }